import { Controller } from "@hotwired/stimulus";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--career-support-partners"
export default class extends Controller {
  static values = {
    entrySheetId: Number,
    webSiteCode: String,
    gtagEvent: String,
  };

  connect() {
    TurboStreamHeaders(this);
  }

  loadContent(e) {
    e.preventDefault();

    const params = {
      resume_entry_sheet_id: this.entrySheetIdValue,
      web_site_code: this.webSiteCodeValue,
      gtag_event: this.gtagEventValue,
    };
    const query = new URLSearchParams(params).toString();

    fetch(`/career_support_partners?${query}`, {
      method: "GET",
      headers: {
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
        // 結果を表示後に処理を行いたい場合は、以下のイベントをフックに実行することができる。
        const event = new CustomEvent(
          "resumin--career_support_partners:loaded",
          {
            detail: { e: e },
          }
        );

        this.element.dispatchEvent(event);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
}
